import { assertEvent, assign } from 'xstate5';

import { removeModificationToActiveModificationsList } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the removal of a modification from the list of active modifications
 * within the customization context.
 */
export const removeModification: CustomizationMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, [
    'customization.remove-modification',
    'customization.dressing.decrease-portions',
  ]);

  const { allModificationsMap, modifications } = context;
  const { ingredientId } = event;

  if (!allModificationsMap || !modifications) {
    return {};
  }

  const { active } = modifications;

  const updatedActives = removeModificationToActiveModificationsList({
    ingredientId,
    activeModifications: active,
    allModificationsMap,
  });

  return { modifications: { ...modifications, active: updatedActives } };
});
